import React from 'react';
import { MapPin, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { DISTRICTS_HP, DISTRICTS_UK } from '../mock/mock';

const DistrictList = ({ title, items, dot }) => (
  <div>
    <div className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-purple-50 text-[#5F259F] text-[11px] font-bold uppercase tracking-wider`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {title}
    </div>
    <ul className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1.5">
      {items.map((d) => (
        <li key={d} className="flex items-center gap-1.5 text-[13px] text-slate-700 hover:text-[#5F259F] cursor-pointer">
          <ChevronRight className="w-3.5 h-3.5 text-[#5F259F]" />
          {d}
        </li>
      ))}
    </ul>
  </div>
);

// Stylized SVG map (illustrative, not geographically exact)
const MapIllustration = () => (
  <svg viewBox="0 0 300 200" className="w-full h-40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hp-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.35" />
        <stop offset="100%" stopColor="#5F259F" stopOpacity="0.55" />
      </linearGradient>
      <linearGradient id="uk-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#A78BFA" stopOpacity="0.35" />
        <stop offset="100%" stopColor="#7C3AED" stopOpacity="0.55" />
      </linearGradient>
    </defs>
    {/* Himachal shape (left) */}
    <path d="M20 90 L45 60 L80 55 L110 65 L130 90 L120 130 L90 145 L50 140 L25 120 Z" fill="url(#hp-grad)" stroke="#5F259F" strokeWidth="1.5" />
    <text x="55" y="105" fill="#5F259F" fontWeight="800" fontSize="11">HIMACHAL</text>
    {/* Uttarakhand shape (right) */}
    <path d="M150 100 L180 75 L215 70 L250 85 L275 105 L265 145 L230 160 L190 155 L160 140 Z" fill="url(#uk-grad)" stroke="#7C3AED" strokeWidth="1.5" />
    <text x="185" y="120" fill="#5F259F" fontWeight="800" fontSize="11">UTTARAKHAND</text>
    {/* Pins */}
    {[[65,90],[95,110],[45,110],[105,80],[195,100],[225,120],[250,110],[210,140]].map(([x,y],i)=>(
      <g key={i}>
        <circle cx={x} cy={y} r="3" fill="#5F259F" />
        <circle cx={x} cy={y} r="6" fill="#5F259F" opacity="0.25" />
      </g>
    ))}
  </svg>
);

const Coverage = () => {
  return (
    <div>
      <div className="mb-5">
        <h3 className="text-2xl lg:text-[26px] font-extrabold text-slate-900">We Serve <span className="gradient-text">Across</span></h3>
        <div className="h-1 w-16 rounded-full gradient-primary mt-2" />
      </div>

      <div className="rounded-2xl bg-white border border-purple-100 soft-shadow p-4">
        <MapIllustration />

        <div className="grid grid-cols-2 gap-5 mt-3">
          <DistrictList title="Himachal Pradesh" items={DISTRICTS_HP} dot="bg-[#5F259F]" />
          <DistrictList title="Uttarakhand" items={DISTRICTS_UK} dot="bg-[#7C3AED]" />
        </div>

        <Button className="mt-5 w-full gradient-primary text-white rounded-xl h-11 font-semibold btn-glow border-0">
          <MapPin className="w-4 h-4 mr-1.5" /> View All Service Areas
        </Button>
      </div>
    </div>
  );
};

export default Coverage;
